export const LABEL_BREAKDOWN = 'Nº de avería: ';
export const OPENING_DATE = 'Fecha de apertura: ';
export const CLOSING_DATE = 'Fecha de cierre: ';
export const TITLE_BREAKDOWN_TIMELINE = 'Seguimiento de avería';
export const LABEL_PENDING = 'Pendiente';

export const SHOW_MORE_STR = 'Ver anteriores';

export const LABEL_BUTTON_INSISTIR = 'Insistir';
export const LABEL_BUTTON_CANCELAR = 'Cancelar';
export const LABEL_BUTTON_CONTINUAR = 'Continuar';
export const LABEL_BUTTON_REUTILIZAR_SOLICITUD = 'Reutilizar solicitud';
export const LABEL_BUTTON_ESTA_SOLUCIONADO = 'Está solucionado';
export const LABEL_BUTTON_NO_SOLUCIONADO = 'Pulsa aquí si tu avería no está solucionada';
export const TEXT_CANNOT_CONTINUE_AUTODIAGNOSIS = '<strong>Llama al 1002</strong> para continuar con tu gestión';

export const LABEL_PEDIR_CITA = 'Pedir cita';
export const LABEL_CAMBIAR_CITA_INSTALADOR = 'Cambiar cita';
export const LABEL_CANCELAR_CITA_INSTALADOR = 'Cancelar cita';
export const LABEL_VER_STOCK_EN_TIENDAS = 'Ver stock en tiendas';
export const LABEL_SIGUE_EL_ENVIO = 'Sigue el envío';
export const SIGUE_EL_ENVIO_DESCRIPCION = 'Comprueba el estado de tu envío:';

export const STOCK_SHOP_TITLE = 'Consulta disponibilidad en tienda';
export const STOCK_SHOP_DESCRIPCION = 'Este es el listado de tiendas con equipamiento disponible. La información del stock de nuestras tiendas es orientativa.';
export const STOCK_SHOP_LABEL_INPUT = 'Introduce una dirección o CP...';
export const STOCK_SHOP_PLACEHOLDER = 'Calle, Ronda de la Comunicación...';
export const STOCK_SHOP_ERROR = 'Ha ocurrido un error, inténtelo de nuevo';
export const STOCK_SHOP_NO_RESULT = 'No hay resultados para la direccion o CP introducido';

export const URL_PEDIR_CITA = 'https://appweb.movistar.es/pages/appointment-booking';

export const RESERVAR_CITA_BUTTON_TITLE = 'Reservar Cita';
export const RESERVAR_CITA_TITLE = '¿Quieres reservar una cita?';
export const RESERVAR_CITA_DESCIPCION1 = 'Si quieres reservar una cita en una de nuestras tiendas pulsa en continuar.';
export const RESERVAR_CITA_DESCIPCION2 = 'La reserva de cita no implica reserva del dispositivo. El dispositivo podría no estar disponible cuando acudas a tu cita.';
export const RESERVAR_CITA_URL = 'https://tiendas.movistar.es/?q=';

export const SEGUIMIENTO_STOCK_DESCIPCION1 = 'Comprueba si tu equipamiento está disponible en tienda y pide una cita.';
export const SEGUIMIENTO_STOCK_DESCIPCION2 = 'Importante: la cita en tienda no implica reserva del dispositivo, por lo que podría no estar cuando acudas a la cita.';

export const CITA_INSTALDOR_DESCRIPCION = 'Tienes una cita pendiente con el instalador. Puedes consultar o cambiar la cita agendada.';

export const MODAL_CANCELAR_CITA_INSTALADOR_TITLE_GENERAL = 'Cancelar cita';
export const MODAL_CANCELAR_CITA_INSTALADOR_TITLE = '¿Seguro que quieres cancelar la cita?';
export const MODAL_CANCELAR_CITA_INSTALADOR_DESCRIPTION = 'Si cancelas tu cita, nos pondremos en contacto contigo en un plazo de 72 horas para concertar una nueva.';
export const MODAL_CANCELAR_CITA_INSTALADOR_BUTTON_LABEL = 'Cancelar cita';
export const MODAL_CANCELAR_CITA_INSTALADOR_SUCCESS = 'Se ha cancelado la cita correctamente';
export const MODAL_CANCELAR_CITA_INSTALADOR_FAILURE = 'Ha ocurrido un error al cancelar la cita';

export const TITLE_AVERIA_ABIERTA = 'Avería abierta';
export const TITLE_AVERIA_FINALIZADA = 'Finalizada';
export const TITLE_AVERIA_CANCELADA = 'Cancelada';
export const TITLE_AVERIA_RENOVAR = 'Diagnóstico: es necesario renovar tu equipo.';
export const TITLE_AVERIA_DOMICILIO = 'Diagnóstico: envío a domicilio';
export const TITLE_AVERIA_TECNICO = 'Diagnóstico: un técnico irá a tu domicilio';
export const TITLE_AVERIA_RESOLUCION = 'Resolución';
export const TITLE_AVERIA_REVISION_TECNICO = 'Diagnóstico: en revisión por equipo técnico';
export const TITLE_AVERIA_CELERIS = 'Estado del envío';
export const TITLE_AVERIA_CITA = 'Cita con técnico en domicilio';

export const SUBTITLE_AVERIA_ABIERTA = 'Estamos gestionando tu avería con la mayor rapidez posible.';
export const SUBTITLE_AVERIA_FINALIZADA = 'Avería resuelta.';
export const SUBTITLE_AVERIA_CANCELADA = 'Avería cancelada.';
export const SUBTITLE_AVERIA_48_HORAS = 'Tienes 48h para retomarlo donde lo dejaste. Pasado ese tiempo tendrás que crear una nueva solicitud de avería.';
export const SUBTITLE_AVERIA_RENOVAR = 'Ve a una tienda Movistar para recoger tu nuevo equipo. Recuerda llevar el antiguo para sustituirlo.';
export const SUBTITLE_AVERIA_DOMICILIO = 'Te enviaremos un dispositivo nuevo a tu domicilio en un plazo aproximado de 4 días.';
export const SUBTITLE_AVERIA_TECNICO = 'Un técnico acudirá a tu domicilio para solucionar la avería. Te llamaremos para concertar día y hora de la visita.';
export const SUBTITLE_AVERIA_RESOLUCION = 'Tienes un plazo de 48h para informar que tu avería no está resuelta.';
export const SUBTITLE_AVERIA_REVISION_TECNICO = 'Estamos analizando tu problema para solucionarlo lo antes posible. Es posible que un técnico se ponga en contacto contigo.';
export const SUBTITLE_AVERIA_ANALISIS_TECNICO = 'Estamos analizando tu problema para solucionarlo lo antes posible. Es posible que un técnico se ponga en contacto contigo.';
export const SUBTITLE_AVERIA_CITA = 'Tienes una cita pendiente con el técnico. Puedes consultar o cambiar la cita agendada.';

export const CANCEL_MODAL_BUTTON = "Cancelar solicitud"
export const CANCEL_MODAL_TITLE= '¿Estás seguro de que deseas cancelar esta solicitud?'
export const CANCEL_MODAL_SUBTITLE = 'Podrás volver a abrir una nueva solicitud siempre que lo desees.'
export const CANCEL_MODAL_OK = "Tu solicitud ha sido cancelada";

export const REITERATE_MODAL_TITLE = "Lamentamos que sigas con problemas técnicos. Vamos a revisar tu solicitud."
export const REITERATE_MODAL_SUBTITLE = "Nos pondremos en contacto contigo si es necesario."
export const REITERATE_MODAL_MESSAGE = "Podrás cancelar esta revisión en cualquier momento desde el Histórico de Soporte."

export const VALIDATE_MODAL_TITLE = "Hemos pasado tu avería al equipo técnico. Contactaremos contigo en breve."

export const STATE_CITA = {
  WO_SIN_CITA: 0, // SI
  WO_GENERADA: 1, // SI
  WO_REALIZADA: 2, // NO
  WO_EXPIRADA: 3, // NO
  WO_CANCELADA: 4, // NO
  WO_NUEVA_ALTA: 5, // SI
};

export const DISALLOWED_STATES_CITA = [
  STATE_CITA.WO_REALIZADA,
  STATE_CITA.WO_EXPIRADA,
  STATE_CITA.WO_CANCELADA,
];

export const MAIN_TITLE = "Averías"

export const MODAL_TYPE_REITERATE = "reiterate"
export const MODAL_TYPE_CANCEL = "cancel"
export const MODAL_TYPE_VALIDATE = "validate"
export const MODAL_TYPE_ERROR = "error"

export const MODAL_RETURN_BUTTON = "Volver"
export const MODAL_ACEPT_BUTTON = "Aceptar"

export const ERROR_MODAL_TITLE = "Algo ha ido mal"
export const ERROR_MODAL_SUBTITLE = "Por favor, inténtalo de nuevo más tarde."